<div class="d-flex justify-content-between mat-elevation-z4 p-2">
    <h4>
        LDS HUB
    </h4>
    <div class="btn-group" role="group">
        <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" [(ngModel)]="Filter"
            value="production">
        <label class="btn btn-outline-danger" for="btnradio1">PRODUCTION</label>
        <input type="radio" class="btn-check" name="btnradio" id="btnradio3" value="test" autocomplete="off"
            [(ngModel)]="Filter">
        <label class="btn btn-outline-success" for="btnradio3">TEST</label>
    </div>
</div>

<hr>

<div class="row g-3 mat-elevation-z4 p-2">
    <div class="col-sm-6" *ngFor="let app of Filter === 'production' ? Production_Applications : Test_Applications">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">
                    {{ app.ApplicationName }}
                </h5>
                <h6 class="card-subtitle mb-2 text-body-secondary">
                    <span class="badge bg-success" *ngIf="app.Production;else testApplicationTemplate">production</span>
                </h6>
                <p class="card-text">
                    {{ app.Description }}
                </p>
                <div class="d-flex">
                    <a [href]="app.Url" class="btn btn-outline-primary  text-nowrap me-2">
                        <i class="bi bi-box-arrow-in-up-right"></i>
                        open application
                    </a>
                    <button class="btn btn-success " disabled *ngIf="app.Active;else inactiveApplicationTemplate">
                        <i class="bi bi-check-lg"></i> active
                    </button>
                </div>
            </div>
        </div>
    </div>




    <ng-template #testApplicationTemplate>
        <span class="badge bg-danger">test</span>
    </ng-template>

    <ng-template #inactiveApplicationTemplate>
        <button class="btn btn-danger  me-2" disabled>
            <i class="bi bi-x-lg"></i>
            disabled
        </button>
    </ng-template>
</div>

<app-mercedes-loader *ngIf="Loading"></app-mercedes-loader>